import PropTypes from 'prop-types';
import { addMinutes, parseISO } from 'date-fns';
import { Link } from 'react-router-dom';

import { ReactComponent as EuroSVG } from 'icons/euro.svg';
import { ReactComponent as StethoscopeSVG } from 'icons/stethoscope.svg';
import { ReactComponent as ClockSVG } from 'icons/table/clock.svg';
import { ReactComponent as UserSVG } from 'icons/user.svg';

import { stageToStringMap } from 'config/teleconsultation';
import { formatDatetime, formatTime } from 'helpers/timezone';

import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';
import { nameDecorator } from 'helpers/name';

const TeleconsultationHeaderCard = ({ data, role }) => {
  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  const doctorName = [
    data.doctor?.lastName?.toUpperCase(),
    data.doctor?.firstName,
  ]
    .filter(Boolean)
    .join(' ');

  const nurseName = [data.nurse?.lastName?.toUpperCase(), data.nurse?.firstName]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="pa5 pt4 br4 shadow-1 bg-grouped-table flex flex-column justify-between">
      <h3 className="flex align-center f2 fw6 ma0 pa0">
        {stageToStringMap[data.stage]}
      </h3>
      <div
        className={
          isMobile
            ? 'mt6 flex flex-column middarkgrey'
            : 'mt6 flex flex-column margin-between middarkgrey'
        }
        style={{ gap: '16px' }}
      >
        <div
          className="flex items-center f7 ma0 nudge-bottom--2"
          style={{ gap: '20px' }}
        >
          {data.tariff && (
            <span className="flex items-center middarkgrey">
              <EuroSVG className="h6 w6 mr2" />
              {data.tariff.name} - €{data.tariff.amount}
            </span>
          )}
        </div>
        <div className="flex items-center f7 ma0 nudge-bottom--2">
          <div className="flex items-center mr6">
            <ClockSVG className="h6 w6 mr2" />
            <span className="middarkgrey">
              {formatDatetime(data.startTime)} -{' '}
              {formatTime(addMinutes(parseISO(data.startTime), 15))}
            </span>
          </div>
          {data.doctor && data.doctor?.id !== null && (
            <div className="flex items-center mr6">
              <StethoscopeSVG className="h6 w6 mr2" />
              <span className="middarkgrey">{doctorName}</span>
            </div>
          )}
          {data.nurse && data.doctor?.id !== null && data.stage === 'nurse' && (
            <div className="flex items-center mr6">
              <StethoscopeSVG className="h6 w6 mr2" />
              <span className="middarkgrey">{nurseName}</span>
            </div>
          )}
          {role !== 'admin' && (
            <div className="flex items-center mr6">
              <UserSVG className="h6 w6 mr2" />
              <Link
                className="middarkgrey underline"
                to={`/customers/${data.customer.id}`}
              >
                {nameDecorator(
                  data.customer?.firstName,
                  data.customer?.lastName,
                )}
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

TeleconsultationHeaderCard.propTypes = {
  data: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    description: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    city: PropTypes.string,
    address: PropTypes.string,
  }),
};

export default TeleconsultationHeaderCard;
